export function muteAllAudio(mute) {
    const elements = [];
    const findAudio = (root) => {
        if (root instanceof HTMLElement || root instanceof ShadowRoot) {
            const found = root.querySelectorAll('audio');
            found.forEach((el) => elements.push(el));
        }
        if ('childNodes' in root) {
            root.childNodes.forEach((child) => {
                if (child instanceof HTMLElement && child.shadowRoot) {
                    findAudio(child.shadowRoot);
                }
                findAudio(child);
            });
        }
    };
    const wrapper = document.getElementById('lk-embed-wrapper');
    if (wrapper) {
        findAudio(wrapper);
        if (wrapper.shadowRoot)
            findAudio(wrapper.shadowRoot);
    }
    else {
        findAudio(document.body);
    }
    elements.forEach((el) => {
        el.muted = mute ? true : false;
    });
}
export function getUTCDateDDMMYYYY(isoString) {
    const date = new Date(`${isoString}Z`);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
}
export function getUTCTimeAMPM(isoString) {
    const date = new Date(`${isoString}Z`);
    return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC',
    });
}
export function sortBySequence(messages) {
    return [...messages].sort((a, b) => a._sequence - b._sequence);
}
/**
 * Ensures an asset path is resolved to an absolute URL pointing back to the agent server.
 * This is critical for embedded scripts where relative paths would otherwise point to the host domain.
 */
export function getAssetUrl(path) {
    if (path.startsWith('http'))
        return path;
    let baseUrl = typeof window !== 'undefined' ? window.__AGENT_BASE_PATH__ : '';
    if (!baseUrl && typeof window !== 'undefined') {
        // Attempt to detect the script's origin at runtime
        const findScriptOrigin = () => {
            // 1. Check currentScript (best for non-module scripts)
            if (document.currentScript instanceof HTMLScriptElement && document.currentScript.src) {
                return new URL(document.currentScript.src).origin;
            }
            // 2. Search all scripts for our bundle filename or the sandbox id
            const scripts = Array.from(document.scripts);
            const ourScript = scripts.find((s) => s.src &&
                (s.src.includes('embed-popup.js') || s.getAttribute('data-lk-sandbox-id')));
            if (ourScript === null || ourScript === void 0 ? void 0 : ourScript.src) {
                return new URL(ourScript.src).origin;
            }
            // 3. Fallback to any remote script that isn't from the current domain
            const remoteScript = scripts.find((s) => s.src && s.src.startsWith('http') && !s.src.includes(window.location.host));
            if (remoteScript === null || remoteScript === void 0 ? void 0 : remoteScript.src) {
                return new URL(remoteScript.src).origin;
            }
            return '';
        };
        baseUrl = findScriptOrigin();
        if (baseUrl) {
            window.__AGENT_BASE_PATH__ = baseUrl;
            console.log('LiveKit Embed: Detected source origin:', baseUrl);
        }
    }
    // Fallback to page origin if detection fails
    const finalBaseUrl = baseUrl ||
        process.env.NEXT_PUBLIC_BASE_URL ||
        (typeof window !== 'undefined' ? window.location.origin : '');
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${finalBaseUrl.replace(/\/$/, '')}${normalizedPath}`;
}
